import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
// import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { getLanguage, getQueryString } from 'utils/params';
import moment from 'moment';
import { OverviewPayment } from '../common';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import DatePicker from 'react-datepicker';
import { Calendar } from 'assets/images/web-isn';
import { addDays, addMonths, parseISO, setHours, subDays } from 'date-fns';
import { checkDateActive } from '../payment.api';
import * as Yup from 'yup';
import { handleDateLocale } from '../common/formatDate';

function StepOneComponent(props) {
  const { apartmentDetail, initialValues, next } = props;
  const { t } = useTranslation();
  const location = useLocation();
  const language = getLanguage(location);
  // const [isShowSubmit, setIsShowSubmit] = useState(false);
  const today = new Date();
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef();
  // const userInfo = useSelector(state => state.loginData.userInfo);
  const [VATCheck, setVATCheck] = useState(initialValues.isVatInvoice);
  const [someoneCheck, setSomeoneCheck] = useState(initialValues.isReservation);
  const [showContinue, setShowContinue] = useState(false);
  const [dateRange, setDateRange] = useState(initialValues.checkInOut);
  const [startDate, endDate] = dateRange;
  const [dateResApi, setDateResApi] = useState([]);
  const [disDay, setDisDay] = useState([]);
  const [resDateError, setResDateError] = useState(false);
  const [equalCheckin, setEqualCheckin] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, []);

  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    checkDateActive(getQueryString({ apartmentId: apartmentDetail?.apartmentId })).then(res => {
      setDateResApi(res.listDate);
    });
  }, [apartmentDetail]);

  useEffect(() => {
    if (startDate !== null && endDate === null) {
      setShowContinue(false);
      setResDateError(false);
    } else if (captchaToken !== null && startDate !== null && endDate !== null) {
      setShowContinue(true);
    } else if (startDate !== null && endDate !== null) {
      checkDateActive(
        getQueryString({
          apartmentId: apartmentDetail?.apartmentId,
          checkIn: moment(startDate).format('YYYY-MM-DD') + ' 14:00:00',
          checkOut: moment(endDate).format('YYYY-MM-DD') + ' 12:00:00',
        }),
      ).then(res => {
        if (res.isActive === false) {
          setDateRange([null, null]);
          setResDateError(true);
        }
      });

      if (
        moment(startDate).format('L') === moment(new Date()).format('L') ||
        moment(startDate).format('L') === moment(addDays(new Date(), 1)).format('L')
      ) {
        setEqualCheckin(true);
      } else {
        setEqualCheckin(false);
      }
    }

    const dateFormatDapicker = [startDate];
    const dateActive = [];
    dateResApi.forEach(item => {
      dateFormatDapicker.push(setHours(parseISO(item), 12));
      dateActive.push(moment(setHours(parseISO(item), 12)).valueOf());
    });
    setDisDay(dateFormatDapicker);

    let date = [];
    let startDate1 = startDate;
    let endDate1 = endDate;
    while (moment(startDate1).valueOf() <= moment(endDate1).valueOf()) {
      date.push(setHours(parseISO(moment(startDate1).format()), 12));
      startDate1 = moment(startDate1).add(1, 'days').format();
    }

    const arrKq = [];
    date.forEach(item => {
      arrKq.push(dateActive.includes(moment(item).valueOf()));
    });
    if (arrKq.includes(true)) {
      setDateRange([null, null]);
      setResDateError(true);
    } else if (arrKq.includes(false) && arrKq.includes(true) === false) {
      setResDateError(false);
      setErrorDatePicker(false);
    }

    //eslint-disable-next-line
  }, [startDate, endDate, dateResApi]);

  useEffect(() => {
    if (resDateError === true) {
      setDateRange([null, null]);
    }
  }, [resDateError]);

  const checkCaptcha = value => {
    if (value) {
      setCaptchaToken(value);
      if (startDate !== null && endDate === null) {
        setShowContinue(false);
      } else setShowContinue(true);
    }
  };

  const [errorDatePicker, setErrorDatePicker] = useState(false);

  const submitForm = values => {
    // submitStepOne(values);
    // console.log(values);
    if (startDate === null && endDate === null) {
      setErrorDatePicker(true);
    } else {
      next(values);
    }
  };

  const validationSchema = Yup.object().shape({
    fullName: Yup.string().required(t('step_one.full_name_is_required')),
    email: Yup.string().required(t('owner_register.email_is_required')).email(t('owner_register.email_is_invalid')),
    phoneNumber: Yup.string()
      .required(t('owner_register.phone_number_is_required'))
      .min(7, t('owner_register.phone_number_min_max'))
      .max(15, t('owner_register.phone_number_min_max')),
    // checkInOut: Yup.object().nullable().required(t('payment_summary.label_checkInOutRequired')),
    // checkInOut: Yup.date().nullable().required(t('payment_summary.label_checkInOutRequired')),
    companyName: VATCheck ? Yup.string().required(t('payment_summary.label_companyNameRequired')) : '',
    companyAddress: VATCheck ? Yup.string().required(t('payment_summary.label_companyAddressRequired')) : '',
    taxCode: VATCheck ? Yup.string().required(t('payment_summary.label_taxCodeRequired')) : '',
    reservationFullName: someoneCheck ? Yup.string().required(t('owner_register.full_name_is_required')) : '',
    reservationEmail: someoneCheck
      ? Yup.string().required(t('owner_register.email_is_required')).email(t('owner_register.email_is_invalid'))
      : '',
  });

  return (
    <>
      <div className="row mx-0 d-block d-lg-flex">
        {/*Mobile content */}
        <div className="payment-step1-mobile">
          <OverviewPayment apartmentDetail={apartmentDetail} startDate={startDate} endDate={endDate} />
        </div>

        {/* Left content */}
        <div className="col-12 col-lg-6 payment-form">
          <div className="payment-form__title">{t('payment.label_sumary')}</div>
          <div className="payment-form__desc">{t('payment.label_reservationDetails')}</div>
          <div className="font-red pb-3">{t('payment.label_indicatesRequired')}</div>

          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={submitForm}
          >
            {formik => {
              const { errors, touched, setFieldValue, setTouched } = formik;
              return (
                <Form id="summaryForm">
                  <div className="form-group">
                    <label className="form-group__label">
                      {t('payment.label_fullName')} <span className="required-star">*</span>
                    </label>
                    <Field
                      type="text"
                      name="fullName"
                      className={errors.fullName && touched.fullName ? 'form-control input-error' : 'form-control'}
                      maxLength={255}
                    />
                    <ErrorMessage name="fullName" component="span" className="error" />
                    {/* <small className="error">{errors?.fullName && errors.fullName}</small> */}
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-group__label">
                      {t('payment.label_email')} <span className="required-star ">*</span>
                    </label>
                    <Field
                      type="text"
                      name="email"
                      className={errors.email && touched.email ? 'form-control input-error' : 'form-control'}
                      maxLength={255}
                    />
                    <ErrorMessage name="email" component="span" className="error" />
                  </div>
                  <div
                    className="font-red pb-4"
                    dangerouslySetInnerHTML={{ __html: t('payment.label_emailDesc') }}
                  ></div>

                  <div className="form-group">
                    <label className="form-group__label">
                      {t('payment.label_phone')} <span className="required-star ">*</span>
                    </label>
                    <Field
                      type="text"
                      name="phoneNumber"
                      className={
                        errors.phoneNumber && touched.phoneNumber ? 'form-control input-error' : 'form-control'
                      }
                      onChange={event =>
                        setFieldValue(
                          event.target.name,
                          event.target.value
                            .replace(/[^\d/+-]/g, '')
                            .replace(/^([+0-9]{3})([0-9]{3})([0-9]{4})$/, '$1$2$3'),
                        )
                      }
                    />
                    <ErrorMessage name="phoneNumber" component="span" className="error" />
                  </div>

                  <div className="form-group">
                    <label className="form-group__label">
                      {t('payment.label_checkInOut')} <span className="required-star ">*</span>
                    </label>
                    <div className="row">
                      <div className="col-12 col-md-12 payment-date-picker">
                        <DatePicker
                          onFocus={e => e.target.blur()}
                          name="checkInOut"
                          selectsRange={true}
                          startDate={startDate}
                          endDate={endDate}
                          dateFormat={
                            language === 'jp' ? 'yyyy年MM月d日' : language === 'en' ? 'MMM d, yyyy' : 'dd/MM/yyyy'
                          }
                          className={
                            (errors.checkInOut && touched.checkInOut) ||
                            resDateError === true ||
                            errorDatePicker === true ||
                            (startDate !== null && endDate === null)
                              ? 'form-control payment-date-picker__input input-error'
                              : 'form-control payment-date-picker__input'
                          }
                          onChange={date => {
                            setDateRange(date);

                            // const newDateFormat = [];
                            // if (date[0] !== null) {
                            //   newDateFormat.push(
                            //     language === 'jp'
                            //       ? moment(date[0]).format('yyyy/MM/DD')
                            //       : language === 'en'
                            //       ? moment(date[0]).format('MM/DD/yyyy')
                            //       : moment(date[0]).format('DD/MM/yyyy'),
                            //   );
                            //   if (date[1] !== null) {
                            //     newDateFormat.push(
                            //       language === 'jp'
                            //         ? moment(date[1]).format('yyyy/MM/DD')
                            //         : language === 'en'
                            //         ? moment(date[1]).format('MM/DD/yyyy')
                            //         : moment(date[1]).format('DD/MM/yyyy'),
                            //     );
                            //   }
                            // }
                            setFieldValue('checkInOut', date);
                          }}
                          excludeDates={disDay}
                          minDate={today}
                          maxDate={addMonths(startDate, 1)}
                        />
                        <img src={Calendar} className="calendar-img" alt="calendar-icon"></img>
                      </div>
                    </div>
                    <ErrorMessage name="checkInOut" component="span" className="error" />
                    {errorDatePicker === true ? (
                      <span className="error">{t('payment_summary.label_checkInOutRequired')}</span>
                    ) : startDate !== null && endDate === null ? (
                      <span className="error">{t('payment_summary.label_checkOutRequired')}</span>
                    ) : resDateError === true ? (
                      <span className="error">{t('payment_summary.label_errorDatepicker')}</span>
                    ) : (
                      ''
                    )}
                  </div>

                  <div className="pb-2">
                    <div className="payment-form__desc">{t('payment.label_yourPayment')}</div>
                    <div className="pb-3">{t('payment.label_prepay')}</div>
                    <div className="d-flex">
                      <label className="payment-form__vat-checkbox">
                        <div className="payment-form__desc">{t('payment.label_VATCheck')}</div>
                        <Field
                          type="checkBox"
                          name="isVatInvoice"
                          checked={VATCheck}
                          onChange={e => {
                            const value = e.target.checked;
                            setFieldValue('isVatInvoice', value);
                            setVATCheck(value);
                            if (value === false) {
                              setFieldValue('companyName', '');
                              setFieldValue('companyAddress', '');
                              setFieldValue('taxCode', '');
                              setTouched({
                                ...touched,
                                companyName: false,
                                companyAddress: false,
                                taxCode: false,
                              });
                            }
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>

                  {VATCheck ? (
                    <div className="vat-form">
                      <div className="form-group">
                        <label>
                          {t('payment.label_companyName')} <span className="required-star ">*</span>
                        </label>
                        <Field
                          type="text"
                          className={
                            errors.companyName && touched.companyName ? 'form-control input-error' : 'form-control'
                          }
                          name="companyName"
                          maxLength={255}
                        />
                        <ErrorMessage name="companyName" component="span" className="error" />
                      </div>

                      <div className="form-group">
                        <label>
                          {t('payment.label_companyAddress')} <span className="required-star ">*</span>
                        </label>
                        <Field
                          type="text"
                          className={
                            errors.companyAddress && touched.companyAddress
                              ? 'form-control input-error'
                              : 'form-control'
                          }
                          name="companyAddress"
                          maxLength={255}
                        />
                        <ErrorMessage name="companyAddress" component="span" className="error" />
                      </div>

                      <div className="form-group">
                        <label>
                          {t('payment.label_taxCode')} <span className="required-star ">*</span>
                        </label>
                        <Field
                          type="text"
                          className={errors.taxCode && touched.taxCode ? 'form-control input-error' : 'form-control'}
                          name="taxCode"
                          maxLength={255}
                        />
                        <ErrorMessage name="taxCode" component="span" className="error" />
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="d-flex">
                    <label className="payment-form__vat-checkbox">
                      <div className="payment-form__desc">{t('payment.label_reservation')}</div>
                      <Field
                        type="checkBox"
                        name="isReservation"
                        checked={someoneCheck}
                        onChange={e => {
                          const value = e.target.checked;
                          setFieldValue('isReservation', value);
                          setSomeoneCheck(value);
                          if (value === false) {
                            setFieldValue('reservationFullName', '');
                            setFieldValue('reservationEmail', '');
                            setTouched({
                              ...touched,
                              reservationFullName: false,
                              reservationEmail: false,
                            });
                          }
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  {someoneCheck ? (
                    <div className="book-someone-form">
                      <div className="payment-form__desc">{t('payment.label_customerInfo')}</div>
                      <div className="form-group">
                        <label>
                          {t('payment.label_fullName2')} <span className="required-star ">*</span>
                        </label>
                        <Field
                          type="text"
                          className={
                            errors.reservationFullName && touched.reservationFullName
                              ? 'form-control input-error'
                              : 'form-control'
                          }
                          name="reservationFullName"
                          maxLength={255}
                        />
                        <ErrorMessage name="reservationFullName" component="span" className="error" />
                      </div>

                      <div className="form-group">
                        <label>
                          {t('payment.label_email2')} <span className="required-star ">*</span>
                        </label>
                        <Field
                          type="text"
                          className={
                            errors.reservationEmail && touched.reservationEmail
                              ? 'form-control input-error'
                              : 'form-control'
                          }
                          name="reservationEmail"
                          maxLength={255}
                        />
                        <ErrorMessage name="reservationEmail" component="span" className="error" />
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {apartmentDetail?.offerItems?.length > 0 ? (
                    <div className="pb-2">
                      <div className="payment-form__desc">{t('payment.label_offer')}</div>

                      {apartmentDetail.offerItems.map((item, index) => {
                        return (
                          <div key={index} className="d-flex justify-content-between pb-3">
                            <div className="d-flex align-items-center">
                              <span>{item.name}</span>
                            </div>
                            <div className="d-flex align-items-center">
                              <span className="font-green">{t('payment.label_free')}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    ''
                  )}

                  <div className="form-group">
                    <div className="payment-form__desc">{t('payment.label_other')}</div>
                    <Field
                      as="textarea"
                      className="form-control area-requirement"
                      name="otherRequirements"
                      rows="6"
                      // onChange={handleChangeInput}
                      // value={inputData.otherRequirements}
                      maxLength={255}
                    />
                  </div>

                  {startDate && endDate && equalCheckin === false ? (
                    <div className="pb-4">
                      <div className="payment-form__desc">{t('payment.label_cancel')}</div>
                      <div className="pb-2">{t('payment.label_cancel_desc')}</div>

                      {/* case 0% */}
                      {/* {today <=
                      moment(subDays(parseISO(moment(startDate).format('YYYY-MM-DD') + 'T13:59:59'), 7)).valueOf() ? (
                        <div className="row pb-2">
                          <div className="col-9">
                            <span>
                              {t('payment.label_cancel1', {
                                date: handleDateLocale(subDays(startDate, 7)),
                              })}
                            </span>
                          </div>
                          <div className="col-3 d-flex justify-content-end align-items-end">
                            <span className="font-red">0%</span>
                          </div>
                        </div>
                      ) : (
                        ''
                      )} */}

                      <div className="row pb-2">
                        <div className="col-9">
                          <span>
                            {t('payment.label_cancel1', {
                              date: handleDateLocale(subDays(startDate, 2)),
                            })}
                          </span>
                        </div>
                        <div className="col-3 d-flex justify-content-end align-items-end">
                          <span className="font-red">50%</span>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-9">
                          <span>{t('payment.label_cancel2', { date: handleDateLocale(subDays(startDate, 2)) })}</span>
                        </div>
                        <div className="col-3 d-flex justify-content-end align-items-end">
                          <span className="font-red">100%</span>
                        </div>
                      </div>
                    </div>
                  ) : equalCheckin === true ? (
                    <div className="pb-4">
                      <div className="payment-form__desc">{t('payment.label_cancel')}</div>
                      <div className="pb-2">{t('payment.label_cancel_desc')}</div>

                      <div className="row">
                        <div className="col-9">
                          <span>{t('payment.label_cancel3')}</span>
                        </div>
                        <div className="col-3 d-flex justify-content-end align-items-end">
                          <span className="font-red">100%</span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </Form>
              );
            }}
          </Formik>
        </div>

        {/* Right content */}
        <div className="payment-step1-right">
          <OverviewPayment apartmentDetail={apartmentDetail} startDate={startDate} endDate={endDate} />
        </div>

        <div className="container">
          <div className="row">
            <div className="col-6 payment-form__captcha">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_KEY_CAPTCHA}
                onChange={checkCaptcha}
                onExpired={() => {
                  setShowContinue(false);
                }}
                hl={`${language === 'vi' ? 'vi' : language === 'en' ? 'en' : 'ja'}`}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center button-confirm-page">
        <button
          type="submit"
          form="summaryForm"
          // onClick={handleNextStep}
          className="button-confirm-page__continue"
          disabled={!showContinue}
        >
          {t('payment.label_buttonContinue')}
        </button>
      </div>
    </>
  );
}

export default StepOneComponent;
